import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  IAlerta,
  ICreateAlerta,
  IListado,
  IQueryParam,
  IUpdateAlerta,
} from 'modelos/src';
import { HttpService } from '../../../auxiliares/http.service';
import { HelperService } from '../../../auxiliares/helper.service';
import { apiBase } from '../../../../environments/environment';

const api = apiBase;

@Injectable({
  providedIn: 'root',
})
export class AlertasService {
  constructor(private http: HttpService) {}

  public listar(queryParams?: IQueryParam): Observable<IListado<IAlerta>> {
    const params = HelperService.getQueryParams(queryParams);
    return this.http.get(`${api}/alertas`, { params });
  }

  public crear(dato: ICreateAlerta): Observable<IAlerta> {
    return this.http.post(`${api}/alertas`, dato);
  }

  public listarPorId(id: string): Observable<IAlerta> {
    return this.http.get(`${api}/alertas/${id}`);
  }

  public editar(id: string, dato: IUpdateAlerta): Observable<IAlerta> {
    return this.http.put(`${api}/alertas/${id}`, dato);
  }

  public eliminar(id: string): Observable<void> {
    return this.http.delete(`${api}/alertas/${id}`);
  }
}
